<template>
    <v-layout
            wrap
            align-start
    >
        <v-flex>
            <v-card class="card--flex-toolbar">
                <v-toolbar flat>
                    <v-toolbar-title class="grey--text">Perfil Empresa</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-form style="width: 100%">
                            <v-layout wrap>
                                <v-flex>
                                    <ckeditor :editor="editor" tag-name="textarea" v-model="form.contenido" :config="editorConfig"></ckeditor>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </v-container>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            color="blue darken-1"
                            class="white--text"
                            :loading="loading"
                            :disabled="loading"
                            @click="sendForm"
                    >
                        Enviar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import axios from 'axios';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import {uploader} from '@components/ckeditor/UploadAdapter';

    export default {
        name: "PerfilEmpresaPage",
        components: {},
        data: () => ({
            editor: ClassicEditor,
            editorConfig: {
                // The configuration of the rich-text editor.
                language: 'es',
                placeholder:"Especifique el perfil de la empresa",
                extraPlugins: [uploader]
            },
            dialog: false,
            loading:false,
            form: {
                contenido: ''
            }
        }),
        mounted() {
            this.loadData();
        },
        methods: {
            loadData(){
                this.loading = true;
                axios.get("/api/empresa-perfil").then(({data})=>{
                    this.form.contenido = data.contenido;
                }).finally(()=>{
                    this.loading = false;
                })
            },
            sendForm() {
                this.loading = true;
                axios.post("/api/empresa-perfil", this.form).then(({data})=>{
                    this.$_showMessage("Perfil de Empresa Actualizado Correctamente");
                    this.form.contenido = data.contenido;
                }).catch(()=>{
                    this.$_showError("Perfil de Empresa Actualizado Correctamente");
                }).finally(()=>{
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
